module.exports = __webpack_public_path__ + "static/media/xls.ef5ba31b.svg";